import React, { useMemo } from 'react';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import StorageIcon from '@mui/icons-material/Storage';
import CloudIcon from '@mui/icons-material/Cloud';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import { useDevelopmentEngines, defaultDevelopmentEngines } from '../../context/DevelopmentEnginesContext';
import useIsMobile from '../../shared/hooks/useIsMobile';
import OverviewMobile from './Overview.mobile';
import OverviewDesktop from './Overview.desktop';

const OverviewFeature = () => {
  const isMobile = useIsMobile();
  const { enginesData } = useDevelopmentEngines();

  const viewModel = useMemo(() => {
    const iconsById = {
      'engine-systems': <LaptopMacIcon />,
      'engine-data': <StorageIcon />,
      'engine-cloud': <CloudIcon />,
      'engine-innovation': <AutoGraphIcon />
    };

    const fallbackIcons = [<LaptopMacIcon />, <StorageIcon />, <CloudIcon />, <AutoGraphIcon />];
    const sourceEngines = Array.isArray(enginesData?.engines) && enginesData.engines.length
      ? enginesData.engines
      : defaultDevelopmentEngines.engines;

    const engines = sourceEngines.map((engine, index) => ({
      ...engine,
      icon: iconsById[engine.id] || fallbackIcons[index] || <LaptopMacIcon />
    }));

    return {
      engines,
      sectionTitle: enginesData?.sectionTitle || defaultDevelopmentEngines.sectionTitle
    };
  }, [enginesData]);

  const View = isMobile ? OverviewMobile : OverviewDesktop;
  return <View engines={viewModel.engines} sectionTitle={viewModel.sectionTitle} />;
};

export default OverviewFeature;
